<h1 mat-dialog-title>
  <fa-icon *ngIf="data.icon" class="faIcon" icon="{{ data.icon }}"></fa-icon>
  <span [innerHTML]="data.title"></span>
  <div mat-button (click)="goOut()" class="btoCLoseModal"><span>×</span></div>
</h1>
<div mat-dialog-content>
  <div [innerHTML]="data.content"></div>
  <button
    mat-button
    [mat-dialog-close]="true"
    class="mat-raised-button mat-primary mt-3 mb-4"
    [innerHTML]="data.btoaccept"
  ></button>
  <div [innerHTML]="data.note"></div>
</div>
